import { TaskFilterType } from "./TaskFilterChips";

const OPEN_TASK_STATUSES_SEARCH = "taskStatus:OPEN|IN_PROGRESS";

/**
 * Returns the default omnisearch string for the tasks page.
 *
 * We default to open/in-progress task statuses so explicit taskStatus URL
 * filters can replace the default without being intersected with a separate
 * virtual status filter. This still includes both ACTIVE and OVERDUE virtual
 * events as long as the underlying task status is OPEN/IN_PROGRESS.
 */
export function getDefaultTaskSearch(
  tenantId: string | undefined,
  activeFilter: TaskFilterType | null
): string {
  const base = `tenantId:${tenantId}`;

  switch (activeFilter) {
    case TaskFilterType.Overdue:
      return `${base} status:OVERDUE`;
    case TaskFilterType.AllButCanceled:
      return `${base} taskStatus:OPEN|IN_PROGRESS|COMPLETED`;
    case TaskFilterType.Open:
    default:
      return `${base} ${OPEN_TASK_STATUSES_SEARCH}`;
  }
}
